module.exports = __webpack_public_path__ + "static/media/Background.c5a97483.png";